<div class="pointer-events-none fixed inset-0 z-[100000]" *transloco="let t">

    @if (drawerService.isOpen()) {
        <!-- Drawer panel (full-screen, slides from right) -->
        <!-- TODO: route animations — implementar slide-from-right en MobileLayoutComponent
             para que la ruta de destino entre por encima del drawer en vez de cerrar+navegar.
             Requiere [@routeAnimations] en el router-outlet y coordinar z-index con el drawer. -->
        <div
            class="pointer-events-auto absolute inset-0 flex flex-col bg-white"
            @drawerSlide
        >
            <!-- Profile header -->
            <div class="ph-drawer-header relative flex items-center gap-3 bg-liga-gradient px-5 py-5">
                <!-- Profile info (tappable → /settings/profile) -->
                <button
                    class="flex min-w-0 flex-1 items-center gap-3 text-left"
                    (click)="navigate('/settings/profile')"
                >
                    <!-- Avatar -->
                    <div class="flex size-13 shrink-0 items-center justify-center rounded-full text-xl font-bold text-white bg-white/20 ring-1 ring-inset ring-white/30">
                        @if (user?.avatarUrl) {
                            <img class="h-full w-full rounded-full object-cover" [src]="user!.avatarUrl" alt="Avatar" />
                        } @else {
                            {{ user?.firstName?.charAt(0)?.toUpperCase() || '?' }}
                        }
                    </div>

                    <!-- Name + email -->
                    <div class="min-w-0 flex-1 text-white">
                        <div class="truncate text-lg font-bold leading-snug">
                            {{ user ? (user.firstName + ' ' + user.lastName) : t('auth.signed_in_as') }}
                        </div>
                        <div class="truncate text-sm text-white/75">
                            {{ user?.email }}
                        </div>
                    </div>
                </button>

                <!-- Close button -->
                <button
                    mat-icon-button
                    class="shrink-0 text-white/80"
                    (click)="close()"
                    aria-label="Cerrar"
                >
                    <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                </button>
            </div>

            <!-- Scrollable content -->
            <div class="flex flex-1 flex-col overflow-y-auto bg-gray-100 px-3.5 pb-4">

                <!-- CUENTA -->
                <p class="px-1.5 pb-2 pt-4 text-xs font-bold uppercase tracking-widest text-gray-400">
                    {{ t('account.drawer.section.account') }}
                </p>
                <div class="overflow-hidden rounded-xl bg-white">
                    <button
                        class="flex w-full items-center gap-3 px-3.5 py-3 text-left"
                        (click)="navigate('/settings/profile')"
                    >
                        <mat-icon class="ph-icon-20 shrink-0 text-gray-500" svgIcon="heroicons_outline:user"></mat-icon>
                        <span class="flex-1 text-md font-medium text-gray-700">{{ t('account.drawer.edit_profile') }}</span>
                        <mat-icon class="shrink-0 text-gray-300 ph-icon-20" svgIcon="heroicons_outline:chevron-right"></mat-icon>
                    </button>
                    <div class="border-t border-gray-100"></div>
                    <button
                        class="flex w-full items-center gap-3 px-3.5 py-3 text-left"
                        (click)="navigate('/settings/conexiones')"
                    >
                        <mat-icon class="ph-icon-20 shrink-0 text-gray-500" svgIcon="heroicons_outline:link"></mat-icon>
                        <span class="flex-1 text-md font-medium text-gray-700">{{ t('account.drawer.connections') }}</span>
                        <mat-icon class="shrink-0 text-gray-300 ph-icon-20" svgIcon="heroicons_outline:chevron-right"></mat-icon>
                    </button>
                </div>

                <!-- PREFERENCIAS -->
                <p class="px-1.5 pb-2 pt-4 text-xs font-bold uppercase tracking-widest text-gray-400">
                    {{ t('account.drawer.section.preferences') }}
                </p>
                <div class="overflow-hidden rounded-xl bg-white">
                    <button
                        class="flex w-full items-center gap-3 px-3.5 py-3 text-left"
                        (click)="navigate('/settings/notificaciones')"
                    >
                        <mat-icon class="ph-icon-20 shrink-0 text-gray-500" svgIcon="heroicons_outline:bell"></mat-icon>
                        <span class="flex-1 text-md font-medium text-gray-700">{{ t('account.drawer.notifications') }}</span>
                        <mat-icon class="shrink-0 text-gray-300 ph-icon-20" svgIcon="heroicons_outline:chevron-right"></mat-icon>
                    </button>
                    <div class="border-t border-gray-100"></div>
                    <button class="flex w-full items-center gap-3 px-3.5 py-3 text-left">
                        <mat-icon class="ph-icon-20 shrink-0 text-gray-500" svgIcon="heroicons_outline:language"></mat-icon>
                        <span class="flex-1 text-md font-medium text-gray-700">{{ t('account.drawer.language') }}</span>
                        <mat-icon class="shrink-0 text-gray-300 ph-icon-20" svgIcon="heroicons_outline:chevron-right"></mat-icon>
                    </button>
                </div>

                <!-- SOPORTE -->
                <p class="px-1.5 pb-2 pt-4 text-xs font-bold uppercase tracking-widest text-gray-400">
                    {{ t('account.drawer.section.support') }}
                </p>
                <div class="overflow-hidden rounded-xl bg-white">
                    <button class="flex w-full items-center gap-3 px-3.5 py-3 text-left">
                        <mat-icon class="ph-icon-20 shrink-0 text-gray-500" svgIcon="heroicons_outline:question-mark-circle"></mat-icon>
                        <span class="flex-1 text-md font-medium text-gray-700">{{ t('account.drawer.help') }}</span>
                        <mat-icon class="shrink-0 text-gray-300 ph-icon-20" svgIcon="heroicons_outline:chevron-right"></mat-icon>
                    </button>
                    <div class="border-t border-gray-100"></div>
                    <button class="flex w-full items-center gap-3 px-3.5 py-3 text-left">
                        <mat-icon class="ph-icon-20 shrink-0 text-gray-500" svgIcon="heroicons_outline:information-circle"></mat-icon>
                        <span class="flex-1 text-md font-medium text-gray-700">{{ t('account.drawer.about') }}</span>
                        <mat-icon class="shrink-0 text-gray-300 ph-icon-20" svgIcon="heroicons_outline:chevron-right"></mat-icon>
                    </button>

                    @if (!isProduction) {
                        <div class="border-t border-gray-100"></div>
                        <button class="flex w-full items-center gap-3 px-3.5 py-3 text-left" (click)="testBugsnag()">
                            <mat-icon class="ph-icon-20 shrink-0 text-gray-500">adb</mat-icon>
                            <span class="flex-1 text-md font-medium text-gray-700">{{ t('common.test_bugsnag') }}</span>
                        </button>
                        <div class="border-t border-gray-100"></div>
                        <button class="flex w-full items-center gap-3 px-3.5 py-3 text-left" (click)="testErrorHandler()">
                            <mat-icon class="ph-icon-20 shrink-0 text-gray-500">adb</mat-icon>
                            <span class="flex-1 text-md font-medium text-gray-700">{{ t('common.test_error_handler') }}</span>
                        </button>
                    }
                </div>

                <!-- Cerrar sesión -->
                <div class="mt-4.5 overflow-hidden rounded-xl bg-white">
                    <button
                        class="flex w-full items-center gap-3 px-3.5 py-3 text-left"
                        (click)="signOut()"
                    >
                        <mat-icon class="ph-icon-20 shrink-0 text-rose-600" svgIcon="heroicons_outline:arrow-right-on-rectangle"></mat-icon>
                        <span class="flex-1 text-md font-medium text-rose-600">{{ t('auth.sign_out_action') }}</span>
                    </button>
                </div>

                <!-- Version -->
                <p class="py-4.5 text-center text-[11px] leading-relaxed text-gray-400">
                    PadelHub v{{ appVersion }}
                </p>

            </div>
        </div>
    }

</div>
